import React, {useEffect, useState} from 'react';
import {Grid,} from "@material-ui/core";
import {DashboardHeader, ImageSection, ProductInfoSection} from '../../components'
import './style.scss'
import {withRouter} from "react-router-dom";

import FlowDiagram from '../../components/flowDiagram'


function ProductSmartDetail(props) {
  const product = props?.location?.state?.product

  const [fullDetail, setFullDetail] = useState(false);

  useEffect(() => {
    setFullDetail(props?.location?.pathname === '/detail')
  }, [props.location])

  return (
    <Grid container direction={'column'} className=' product-detail-container p-20 content-main-container'>
      <DashboardHeader pageTitle={'Product Detail'}/>
      <Grid container className={`mt-20 `}>
        <Grid item lg={5} md={5}>
          <ImageSection fullDetail={fullDetail} image={product ? product.imagePath : ''}/>
        </Grid>

        <Grid item lg={7} md={7}>
          <ProductInfoSection product={product} {...props} fullDetail={false}/>
        </Grid>

      </Grid>
      <div className='mt-60 '>
        <FlowDiagram/>
      </div>
    </Grid>
  );
}

export default withRouter(ProductSmartDetail);
